import { render, staticRenderFns } from "./GrowthDisplay.vue?vue&type=template&id=2d9005df&scoped=true"
import script from "./GrowthDisplay.vue?vue&type=script&lang=js"
export * from "./GrowthDisplay.vue?vue&type=script&lang=js"
import style0 from "./GrowthDisplay.vue?vue&type=style&index=0&id=2d9005df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9005df",
  null
  
)

export default component.exports